<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>Recipient List</strong>
        </span>
        <span style="float:right">
            <a [routerLink]="['recipientadd']">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2"  [appHasPermission]="{'Url': '/uspiRecipient/add', 'method':'post', 'menu': 'UPSI Recipient'}" type="button">
                    <i class="fa fa-plus"></i>&nbsp;Add Recipient</button>
            </a>
            &nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-primary pull-right" data-toggle="modal"
            [appHasPermission]="{'Url': '/uspiRecipient/add', 'method':'post', 'menu': 'UPSI Recipient'}"    data-target="#CsvUpload">EXCEL File Upload </button>
        </span>
    </div>
    <section class="card search-box">
        <div class="card-header" (click)="toggleSearchDiv()">Modify Search <span
                class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
        <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
            <div class="row">
                <div class="col-lg-12">

                    <div class="row">
                        <div class="col-sm-2">
                            <label>Name :</label>

                            <div class="input-group">
                                <input [(ngModel)]="recipientName" [ngModelOptions]="{standalone: true}">

                            </div>
                        </div>


                        <div class="col-sm-2">
                            <label>Recipient Code:</label>

                            <div class="input-group">
                                <input [(ngModel)]="recipientEmpCode" [ngModelOptions]="{standalone: true}">

                            </div>
                        </div>


                        <div class="col-sm-2">
                            <label>Company Name:</label>
                            <div class="input-group">
                                <input [(ngModel)]="recipientDesignation" [ngModelOptions]="{standalone: true}">
                            </div>

                        </div>
                        <div class="col-sm-2">
                            <label>Unique Identifier :</label>
                            <div class="input-group">
                                <select [(ngModel)]="recipientUniqueIdentifier" class="form-control"
                                    [ngModelOptions]="{standalone:true}">
                                    <option value='' [selected]="true">Select</option>
                                    <option value="PAN">PAN</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-sm-2">
                            <label>Document No:</label>
                            <div class="input-group">
                                <input [(ngModel)]="recipientDocument" [ngModelOptions]="{standalone: true}">
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <label>Email ID:</label>
                            <div class="input-group">
                                <input [(ngModel)]="recipientEmail" [ngModelOptions]="{standalone: true}">
                            </div>
                        </div>
                    </div>

                    <!-- Second Row: Date Range, Checkboxes, and Buttons -->
                    <div class="row second-row">
                        <div class="col-sm-4 date-range-col">
                            <label>Created Date Range:</label>
                           
                            <div class="date-range-wrapper" (click)="$event.stopPropagation()">
                                <div class="date-input-wrapper">
                                    <span class="date-label">From:</span>
                                    <input class="form-control date-input" [(ngModel)]="SearchDateFrom"
                                        placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle();r.close();" (document:click)="c.close();" (ngModelChange)="onDateFromChange(c)"
                                        [ngModelOptions]="{standalone: true}">
                                    <button class="date-calendar-btn" (click)="c.toggle();r.close();" type="button">
                                        <span class="fa fa-calendar"></span>
                                    </button>
                                </div>
                                <div class="date-input-wrapper">
                                    <span class="date-label">To:</span>
                                    <input class="form-control date-input" [(ngModel)]="SearchDateTo"
                                        placeholder="dd-mm-yyyy" ngbDatepicker #r="ngbDatepicker"
                                        (click)="r.toggle();c.close();" (document:click)="r.close();" (ngModelChange)="onDateToChange(r)"
                                        [ngModelOptions]="{standalone: true}">
                                    <button class="date-calendar-btn" (click)="r.toggle();c.close();" type="button">
                                        <span class="fa fa-calendar"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isMakerCheckerUsed" class="col-md-1 checkbox-col">
                            <div class="checkbox-wrapper">
                                <label for="showUnapproved">Show Unapproved:</label>
                                <input type="checkbox" id="isShowUnapproved_" class="custom-checkbox" [(ngModel)]="isShowUnapproved" [ngModelOptions]="{standalone:true}">
                            </div>
                        </div>
                        <div class="col-md-1 checkbox-col">
                            <div class="checkbox-wrapper">
                                <label for="EncryptPAN">Encrypt PAN:</label>
                                <input type="checkbox" id="isEncryptPAN_" class="custom-checkbox" (change)="handleCheckboxChange()" [(ngModel)]="isShowEncryptedPAN" [ngModelOptions]="{standalone:true}">
                            </div>
                        </div>
                        <div class="col-sm-2 buttons-col">
                            <label>&nbsp;</label>
                            <div class="buttons-wrapper">
                                <button type="button" class="btn btn-sm btn-primary btn-search" (click)=" searchData();">
                                    <i class="fa fa-search"></i>&nbsp;Search</button>
                                <button type="button" class="btn btn-sm btn-default btn-clear" (click)="clear()">
                                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div class="table-responsive">


                        <table id="datatableMeeting" class="table table-hover compact cell-border nowrap stripe">

                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal " id="deleteRecipientConfirmation" tabindex="-1" role="dialog" data-backdrop="static"
        data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDeletion">
                        <i class="fa fa-question-circle-o mr-2"></i>&nbsp;Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            Are you sure you want to delete Recipient?
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteRecipient()"
                        data-dismiss="modal">
                        <i class="fa fa-check"></i>&nbsp;Yes</button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;No</button>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="modal" id="historyModelr" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true" style="position: fixed;
    top: 0;
    right: 40px !important;
    bottom: 0;left: -631px;width:2200px;">
        <div class="modal-dialog  modal-lg" role="document" style="width:1620px;">
            <div class="modal-content" style="width:1500px;">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDeletion">
                        <span class="icmn-history" style="margin-right: 10px"></span>History</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button> -->
    <div class="modal" id="historyModelr" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog  modal-lg" role="document" style="max-width: 100% !important;">
            <div class="modal-content" >
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDeletion">
                        <span class="icmn-history" style="margin-right: 10px"></span>History</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>

                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">

                            <table datatable [dtOptions]="dtRecipientHistory" [dtTrigger]="dtHistoryTrigger"
                                class="table table-hover compact cell-border nowrap stripe" id="reHistorytable"
                                style="cursor: pointer;">
                                <thead>
                                    <tr>

                                        <th>Operation Type</th>
                                        <th>Operation Date and Time</th>
                                        <th>Created By</th>
                                        <th>Modified By</th>
                                        <th>Ip Address</th>
                                        <th>Name</th>
                                        <th>Recipient Code</th>
                                        <th>Designation</th>
                                        <th>Company </th>
                                        <th>Unique Identifier Type</th>
                                        <th>Document File</th>
                                        <th style="display:none">Other Document Name</th>
                                        <th>Document No</th>
                                        <th>Email Id</th>
                                        <th>Address 1</th>
                                        <th>Address 2</th>
                                        <th>Address 3</th>
                                        <th>City</th>
                                        <th>Pin</th>
                                        <th>Type of Recipient</th>
                                        <th>Contact Number</th>
                                        <th>Tel Number</th>
                                        <th style="display:none">ODAte</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let History of recipientHistory; let count=index"
                                        style="line-height: 25px;">

                                        <td tabindex="1">{{(History.o == 'u')?'Update':'Insert'}}</td>
                                        <td tabindex="1">{{History.t | date : "dd-MM-y hh:mm a"}}</td>
                                        <td tabindex="1">{{History.CreatedByUserName }}</td>
                                        <td tabindex="1">{{History.ModifiedByUserName }}</td>
                                        <td tabindex="1">{{History.d.ip_address}}</td>
                                        <td tabindex="1">{{History.d.Name }}</td>
                                        <td tabindex="1">{{History.d.EmpCode }}</td>
                                        <td tabindex="1">{{History.d.Designation }}</td>
                                        <td tabindex="1">{{History.d.Department }}</td>
                                        <td tabindex="1">
                                            {{History.d.Unique_Identifier_Type == 'Other'? History.d.other_document_name : History.d.Unique_Identifier_Type }}
                                        </td>
                                        <td>{{History.d.DocumentFile | slice:14}}</td>
                                        <td tabindex="1" style="display:none">{{History.d.other_document_name }}</td>
                                        <td tabindex="1">{{History.d.Document_No | uppercase}}</td>
                                        <td tabindex="1">{{History.d.email_id }}</td>
                                        <td>{{History.d.Address_1 }}</td>
                                        <td>{{History.d.Address_2 }}</td>
                                        <td>{{History.d.Address_3 }}</td>
                                        <td>{{History.d.city }}</td>
                                        <td>{{History.d.pin }}</td>
                                        <td>{{ History.d.type_of_recipient == "Other"?  History.d.other_recipient : History.d.type_of_recipient }}
                                        </td>
                                        <td tabindex="1">{{History.d.ContactNumber }}</td>
                                        <td tabindex="1">{{History.d.tele_Number }}</td>
                                        <td style="display:none">{{History.t | date : "yMMddHHmm"}}</td>


                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Ok</button>
                </div>
            </div>
        </div>
    </div>


    <div class="modal" id="CsvUpload" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Upload Excel File</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>

                </div>
                <div class="modal-body">
                    <div class="row">

                            <div class="col-sm-12">
                                    <div class="input-group" style="margin-left: 5px;" title="Download Format File">
                                        <a href=".././../../assets/format_files/Recipient Upload Format File.xlsx"
                                            class="btn btn-sm btn-primary">Download Format File
                                            <span class="fa fa-download"></span>
                                        </a>
                                    </div>
                                </div>
                              

                    </div>
                    <br>
                    <div class="row">
                        

                        <div class="col-sm-12">
                            <input type="file" id="fileInput" accept=".xlsx" class='form-control' (change)="fileChanged($event)">
                            <span style="color: red" *ngIf="fileSizeError">File size is greater than 2MB</span>
                            <span style="color: red" *ngIf="fileExtensionError">Please upload excel file only.</span>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" (click)="upload()" [disabled]="isUploadNotValid"
                        class="btn btn-sm btn-primary" data-dismiss="modal">
                        Upload</button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Cancel</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal" id="notInsertdata" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
    aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog  modal-lg" role="document" style="max-width: 97% !important;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDeletion">
                    Below Records are not uploaded</h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                </button>

            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12">

                        <table datatable [dtOptions]="dtnotInsertdata" [dtTrigger]="dtnotInsertdataTrigger"
                            class="table table-hover compact cell-border nowrap stripe" id="CsvUploadtable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th style="min-width: 200px">Error Messages</th>
                                    <th>Name <span style="color: red">(*Required)</span></th>
                                    <th>Email Id <span style="color: red">(*Required)</span></th>
                                    <th>Recipient Code</th>
                                    <th>Unique Identifier Type  <span style="color: red">(*Required)</span></th>
                                    <th>Document No  <span style="color: red">(*Required)</span></th>
                                    <th>Other Document Name</th>
                                    <th>Designation</th>
                                    <th>Company <span style="color: red">(*Required)</span></th>
                                    <th>Contact Number  <span style="color: red">(*Required)</span></th>
                                    <th>Tel Number</th>
                                    <th>Address_1 <span style="color: red">(*Required)</span></th>
                                    <th>Address_2</th>
                                    <th>Address_3</th>
                                    <th>City</th>
                                    <th>Pin</th>
                                    <th>Type of Recipient <span style="color: red">(*Required)</span></th>
                                    <th>Other Recipient</th>                       
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let notinserted of notinserteddata; let count=index"
                                    style="line-height: 25px;">  
                                    <td style="min-width: 200px"> <li *ngFor="let msg of notinserted.error_msg">
                                        <span >{{msg}}</span>

                                    </li></td>                                 
                                    <td tabindex="1">{{notinserted.Name }}</td>
                                    <td tabindex="1">{{notinserted.email_id }}</td>
                                    <td tabindex="1">{{notinserted.EmpCode   }}</td>
                                    <td tabindex="1">{{notinserted.Unique_Identifier_Type }}</td>
                                    <td tabindex="1">{{notinserted.Document_No | uppercase }}</td>
                                    <td tabindex="1">{{notinserted.other_document_name }}</td>
                                    <td tabindex="1">{{notinserted.Designation }}</td>
                                    <td tabindex="1">{{notinserted.Department }}</td>  
                                    <td tabindex="1">{{notinserted.ContactNumber }}</td> 
                                    <td tabindex="1">{{notinserted.tele_Number }}</td>
                                    <td tabindex="1">{{notinserted.Address_1 }}</td>
                                    <td tabindex="1">{{notinserted.Address_2 }}</td>
                                    <td tabindex="1">{{notinserted.Address_3 }}</td>
                                    <td tabindex="1">{{notinserted.city }}</td>
                                    <td tabindex="1">{{notinserted.pin }}</td>
                                    <td tabindex="1">{{notinserted.type_of_recipient }}</td>
                                    <td tabindex="1">{{notinserted.other_recipient }}</td>
                             </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                    <i class="fa fa-times"></i>&nbsp;Ok</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade modal-size-medium" id="upsiDetailsFileDownloadDialog" tabindex="-1" role="dialog"
                data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <i class="fa fa-upload"></i>
                                <span id="UpsiFileDownloadTitle"></span>
                            </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="col-md-12">
                                <div class="row collapse1">
                                    <span class="cat__core__title">
                                        UPSI Files
                                    </span>

                                    <table class="table table-hover compact cell-border nowrap stripe"
                                        style="cursor: pointer;">
                                        <thead>
                                            <tr>

                                                <th>Filename</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="fileNameArray">
                                            <tr  *ngFor="let file of fileNameArray; let index = index">
                                                <td tabindex="1" style="cursor: move; width: 70%;">
                                                    {{file}}
                                                </td>
                                                <td>
                                                    <button type="button" class="btn-sm btn btn-warning"
                                                       (click)="downloadRecipentDoc(file)">
                                                        <span class="fa fa-download"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">

                            <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                                <i class="fa fa-times"></i>&nbsp;Close</button>

                        </div>
                    </div>
                </div>
        </div>



</section>
<app-alert></app-alert>